module.exports = __webpack_public_path__ + "img/bmh_new.82aed94b.jpg";